












import { defineComponent, PropType } from '@vue/composition-api';
import { mapGetters } from 'vuex';
import { IPaymentPlan } from '@/models';
import { IPaymentPlanStateVisual } from '@/store/payment-plan';

export default defineComponent({
  name: 'PaymentPlanStatusDisplay',

  props: {
    paymentPlan: { type: Object as PropType<IPaymentPlan>, required: true }
  },

  computed: {
    ...mapGetters({
      getPaymentPlanStateVisualByState:
        'paymentPlan/getPaymentPlanStateVisualByState'
    }),

    paymentPlanState(): IPaymentPlanStateVisual {
      return this.getPaymentPlanStateVisualByState(this.paymentPlan.state);
    }
  }
});
